<!--
    描述：造价分析首页列表
    时间：2020-07-14
    Created by ws
-->
<template>
	<div class="w-table-layout w-table-page">
		<div class="w-table-content"
			 ref="tableContent">
			<el-table ref="xTable"
					  height="100%"
					  :data="filterData"
					  highlight-current-row
					  border
					  v-loading="loading"
					  stripe
					  @selection-change="handldChange">
				<el-table-column type="index"
								 label="序号"
								 align="center"
								 width="60">
					<template slot-scope="scope">
						{{ scope.$index + 1 }}
						<!-- <el-tooltip placement="right"
									effect="light"
									v-if="scope.row.tags !== ''">
							<div slot="content"
								 class="tag-label-tooltip">
								<el-tag class="mr10 mb10"
										size="mini"
										v-for="(item, index) in toArray(scope.row.tags)"
										:key="index">{{ item }}</el-tag>
							</div> -->
						<svg-icon v-if="scope.row.tags !== ''"
								  icon-class="biaoqian"
								  class="ml5 custom-tag"></svg-icon>
						<!-- </el-tooltip> -->
					</template>
				</el-table-column>
				<el-table-column prop="projectName"
								 label="工程名称"
								 align="center"
								 min-width="190"
								 show-overflow-tooltip>
					<template slot-scope="scope">
						<a class="rowName"
						   @click="goBase(scope.row,'Base')">{{ scope.row.projectName }}</a>
					</template>
				</el-table-column>
				<el-table-column prop="projectPatten"
								 label="工程类型"
								 align="center"
								 width="130"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="projectOrigin"
								 label="项目来源"
								 align="center"
								 width="130"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="beginDate"
								 label="开工年份"
								 min-width="120"
								 align="center"
								 sortable
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="endDate"
								 label="竣工年份"
								 min-width="120"
								 align="center"
								 sortable
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="areaName"
								 label="地区"
								 min-width="120"
								 align="center"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="companyBuild"
								 label="建设单位"
								 align="center"
								 min-width="120"
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="bidMethod"
								 label="招标方式"
								 align="center"
								 min-width="110"
								 show-overflow-tooltip></el-table-column>
				<!-- <el-table-column prop="declared"
								 label="申报金额类型"
								 align="center"
								 min-width="120"
								 show-overflow-tooltip></el-table-column> -->
				<el-table-column prop="moneyContractPrice"
								 label="合同金额"
								 header-align="center"
								 align="right"
								 min-width="110"
								 sortable
								 show-overflow-tooltip></el-table-column>
				<el-table-column prop="tags"
								 label="标签"
								 header-align="center"
								 align="left"
								 min-width="110"
								 show-overflow-tooltip></el-table-column>
				<!-- <el-table-column align="center"
								 width="150">
					<template slot="header"
							  slot-scope="scope">操作
					</template>
					<template slot-scope="scope">
						<el-button-group>
							<el-button type="text"
									   icon="el-icon-view"
									   class="ml10"
									   title="造价总览"
									   @click="goBase(scope.row,'Total')"></el-button>
							<el-button type="text"
									   icon="el-icon-s-data"
									   class="ml10"
									   title="六算分析表"
									   @click="goBase(scope.row,'Chart')"></el-button>
							<el-button type="text"
									   icon="el-icon-pie-chart"
									   class="ml10"
									   title="六算分析图"
									   @click="goBase(scope.row,'Pie')"></el-button>
                            <el-button type="text"
									   icon="el-icon-zoom-in"
									   class="ml10"
									   title="详细分析"
									   @click="goBase(scope.row,'Detail')"></el-button>
							<el-button type="text"
									   icon="el-icon-data-line"
									   class="ml10"
									   title="指标分析"
									   @click="goBase(scope.row,'Target')"></el-button>
						</el-button-group>
					</template>
				</el-table-column> -->
			</el-table>
		</div>
		<div class="w-table-footer">
			<el-pagination @size-change="handleSizeChange"
						   @current-change="handleCurrentChange"
						   :current-page="currentPage"
						   :page-sizes="pageList"
						   :page-size="pageSize"
						   :total="total"
						   layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>

		<!-- 编辑项目弹窗 -->
		<el-dialog title="编辑项目信息"
				   :visible.sync="editVisible"
				   width="40%">
			<el-form :model="dialogData"
					 label-width="100px">
				<el-row>
					<el-col :span="11">
						<el-form-item label="工程名称"
									  prop="projectName">
							<el-input placeholder="请输入"
									  v-model="dialogData.projectName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="开工日期"
									  prop="beginDate">
							<el-date-picker v-model="dialogData.beginDate"
											type="date"
											format="yyyy 年 MM 月 dd 日"
											value-format="yyyy-MM-dd"
											placeholder="请选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="竣工日期"
									  prop="completeDate">
							<el-date-picker v-model="dialogData.completeDate"
											type="date"
											format="yyyy 年 MM 月 dd 日"
											value-format="yyyy-MM-dd"
											placeholder="请选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="地区"
									  prop="area">
							<el-cascader v-model="dialogData.area"
										 :options="areaList"
										 @change="areaChange"
										 placeholder="请选择"></el-cascader>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="申报金额类型"
									  prop="declaredType">
							<el-select v-model="dialogData.declaredType"
									   placeholder="请选择">
								<el-option v-for="(item, index) in declaredTypeList"
										   :key="'申报类型' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="工程类型"
									  prop="projectPatten">
							<el-select v-model="dialogData.projectPatten"
									   placeholder="请选择">
								<el-option v-for="(item, index) in typeList"
										   :key="'类型' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="建设单位"
									  prop="companyBuild">
							<el-input placeholder="请输入"
									  v-model="dialogData.companyBuild"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="施工单位"
									  prop="companyConstruction">
							<el-input placeholder="请输入"
									  v-model="dialogData.companyConstruction"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="审计单位"
									  prop="companyAudit">
							<el-input placeholder="请输入"
									  v-model="dialogData.companyAudit"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="招标方式"
									  prop="bidMethod">
							<el-select v-model="dialogData.bidMethod"
									   placeholder="请选择">
								<el-option v-for="(item, index) in biddingList"
										   :key="'招标方式' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="合同价"
									  prop="moneyContractPrice">
							<el-input placeholder="请输入"
									  type="number"
									  v-model="dialogData.moneyContractPrice">
								<template slot="append">元</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="审定价"
									  prop="moneyAuthorizedPrice">
							<el-input placeholder="请输入"
									  type="number"
									  v-model="dialogData.moneyAuthorizedPrice">
								<template slot="append">元</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="备注"
									  prop="tag">
							<el-input placeholder="请输入"
									  type="textarea"
									  :autosize="{ minRows: 2, maxRows: 5}"
									  v-model="dialogData.tag"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="文件上传">
							<my-upload :aid="aid"
									   :mode="rowType"
									   ref="myUpload"
									   :acceptType="acceptType"
									   @on-upload="onUpload"></my-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer"
				  class="dialog-footer">
				<el-button @click="editVisible = false">取 消</el-button>
				<el-button type="primary"
						   @click="saveUpdate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
const myUpload = () =>
	import('@/views/project-management/project-add/components/upload')
import { mapState } from 'vuex'
import { getProjectList } from '@/api/modules/project_manage'
import { getItem, setItem, removeItem } from '@/utils/auth'
import { getAllAreaTree } from '@/api/modules/dict'
import { updateBusProContract } from '@/api/modules/dataProject'

export default {
	name: 'Project-list',
	components: { myUpload },
	props: {
		showFilter: {
			type: Boolean,
			default: true,
		},
		rowType: {
			type: String,
			default: 'add',
		},
	},
	data() {
		return {
			declaredTypeList: [
				{ sname: '当期金额', value: 0 },
				{ sname: '累计金额', value: 1 },
			],
			acceptType: [],
			aid: '', // 上传组件业务表ID
			areaList: [],
			dialogData: {},
			editVisible: false,
			loading: false,
			tableH: 0,
			colors: [
				{ color: '#f56c6c', percentage: 20 },
				{ color: '#e6a23c', percentage: 40 },
				{ color: '#5cb87a', percentage: 60 },
				{ color: '#1989fa', percentage: 80 },
				{ color: '#6f7ad3', percentage: 100 },
			],
			// 进度内容
			progressList: [
				{
					title: '基本信息',
					value: 90,
				},
				{
					title: '项目结构',
					value: 70,
				},
				{
					title: '造价文件',
					value: 40,
				},
				{
					title: '跟踪审计',
					value: 20,
				},
			],
			// 表格绑定的数据
			filterData: [],
			deleteList: [],
			// 请求参数
			queryParams: {
				beginDateList: [],
				curArea: [],
				projectOriginList: [],
				projectName: '',
				projectPattenList: [],
				tags: [],
			},
			// 造价分析数组
			analysisList: [],
			// 分页参数
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
		}
	},
	created() {
		// 初始请求地区数组
		this.getAreaList()
		// 请求数据
		this.getlistData()
	},
	mounted() {
		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 请求地区数组
		getAreaList() {
			getAllAreaTree({})
				.then((res) => {
					this.areaList = res.data
				})
				.catch((err) => {})
		},
		//编辑项目信息
		saveUpdate() {
			let params = Object.assign({}, this.dialogData)
			params.startDate = this.dialogData.beginDate
			updateBusProContract(params)
				.then((res) => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
				.catch((err) => {
					this.$message.error(err)
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
			this.$message.success('保存成功')
			this.editVisible = false
			this.getlistData()
		},
		// 上传事件回调
		onUpload(status) {
			if (status) {
				this.$emit('onSuccess')
			} else {
				this.$emit('onCancel')
			}
		},

		// 地区数组切换事件
		areaChange(val) {
			this.dialogData.area = val[val.length - 1]
		},
		//编辑项目
		editProject(params) {
			this.editVisible = true
			this.dialogData = params
		},

		//获得项目列表数据
		getlistData() {
			let params = this.$utils.clone(this.queryParams, true)
			params.tags = params.tags.length > 0 ? params.tags.join(',') : ''
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize

			getProjectList(params)
				.then((res) => {
					this.loading = false
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
					// 设置回显
					this.setChecked()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 复选框回显处理
		setChecked() {
			let _checkList = []
			let arr = JSON.parse(getItem('projectList'))
			if (arr && arr.length > 0) {
				arr.map((x) => {
					let _row = this.filterData.find((y) => y.id === x.projectId)
					_row ? _checkList.push(_row) : ''
				})
			}

			setTimeout(() => {
				_checkList.forEach((v) =>
					this.$refs.xTable.toggleRowSelection(v, true)
				)
			}, 10)
		},

		// 上传事件回调
		onUpload(status) {
			if (status) {
				this.$emit('onSuccess')
			} else {
				this.$emit('onCancel')
			}
		},

		// 展示标签
		toArray(str) {
			let arr = str.split(',').filter((x) => x !== '')
			return arr
		},

		//编辑项目
		eidtProject(params) {
			this.editVisible = true
			this.dialogData = params
		},

		//进入基本信息页面 等
		goBase(row, type) {
			let origin = window.location.origin + window.location.pathname
			let path = ''
			let tabName = ''
			let projectName = row.projectName
			let projectSource = row.source || 0
			let userName = this.userInfo.sname
			switch (type) {
				// 项目基本信息
				case 'Base':
					path = 'project-info'
					tabName = 'baseInfo'
					break
				// 造价总览
				case 'Total':
					path = 'cost-overview'
					break
				// 六算分析表
				case 'Chart':
					path = 'analysis-sheet'
					break
				// 六算分析图
				case 'Pie':
					path = 'analysis-chart'
					break
				// 详细分析
				case 'Detail':
					path = 'analysis-detail'
					break
				default:
					path = 'analysis-target'
			}
			// 跳转窗口
			window.open(
				`${origin}#${path}?projectId=${row.id}&source=${projectSource}&tabName=${tabName}&noHeader=true&projectName=${projectName}&userName=${userName}`,
				'_blank'
			)
		},

		// 触发复选框事件时
		handldChange(arr) {
			// 造价分析数组
			this.analysisList = [...arr]

			// 删除ID 数组
			this.deleteList = []
			arr.forEach((x) => {
				this.deleteList.push(x.id)
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getlistData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getlistData()
		},
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
		}),
		...mapState('dict', {
			typeList: (state) => state.gclx, //项目类型数组
			biddingList: (state) => state.zbfs, //招标方式
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
	watch: {
		showFilter(val) {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		},
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		},
	},
}
</script>

<style scoped lang="less">
.progress-cell {
	display: flex;
	justify-content: center;
}

.progress-content {
	min-width: 240px;
}

.progress-row {
	height: 18px;
	line-height: 18px;
}
</style>